<template>
  <q-page padding class=" window-width row justify-center">
    <div class="col-12 col-sm-8">
      <q-form @submit.prevent.stop="register">
        <q-card>
          <q-toolbar class="bg-primary text-white">
            <q-toolbar-title>Регистрация</q-toolbar-title>
          </q-toolbar>
          <q-card-section class="q-gutter-md">
            <q-input v-model="newUser.email" :rules="[requiredRule, emailRule]" dense square outlined name="email"
                     label="Email"/>
            <q-input v-model="newUser.phone" :rules="[requiredRule, phoneRule]" dense square outlined
                     label="Номер телефона"/>
            <q-input v-model.trim="newUser.username" :rules="[requiredRule, nameRule]" dense square outlined
                     label="Имя"/>
            <q-input v-model="newUser.password" :rules="[requiredRule, passwordRule]" dense square outlined
                     type="password" label="Пароль"/>
          </q-card-section>
          <q-card-actions>
            <q-btn
                no-caps
                type="submit"
                color="primary"
                label="Зарегистрироваться"
                class=" form-button"
            />
            <q-btn
                no-caps
                to="/login"
                label="У вас уже есть аккаунт?"
                color="primary" flat
            />
          </q-card-actions>
        </q-card>
      </q-form>

    </div>
  </q-page>
</template>

<script setup lang="ts">
import {reactive} from "vue"
import {useRegister} from "../composables/auth";
import {requiredRule, emailRule, phoneRule, nameRule, passwordRule} from "../util/rules"
import {useQuasar} from "quasar";
import {RegisterRequest} from "../models/auth";
import {useRoute} from "vue-router";

const route = useRoute()
const newUser: RegisterRequest = reactive({email: route.query.email, username: "", password: "", phone: ""})

const $q = useQuasar()
const {execute} = useRegister(newUser)

async function register() {
  await execute(true)
  $q.dialog({
    message: "Для подтверждения аккаунта перейдите по ссылкe на электронной почте",
    ok: {
      to: "/login",
      flat: true
    },
    cancel: false,
    persistent: true
  })
}
</script>

<style scoped>

</style>